import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import NotFound from "./component/Pages/NotFound/NotFound";

/*
  Existing page components preserved below (uncomment to restore site):
  import { useState } from "react";
  import { useLocation } from "react-router-dom";
  import Navbar from "./component/Header/Navbar";
  import Contact from "./component/Pages/Contact/Contact";
  import Home from "./component/Pages/Home/Home";
  import Footer from "./component/Footer/Footer";
  import About from "./component/Pages/About/About";
  import Service from "./component/Pages/Services/Service";
  import Blog from "./component/Pages/Blogs/Blog";
  import BlogData from "./component/Pages/Blogs/BlogData/BlogData";
  import Carrier from "./component/Pages/carrier/Carrier";
  import Aboutdoctor from "./component/Pages/Aboutdoctor/Aboutdoctor";
  import ServiceData from "./component/Pages/Services/Services/ServiceData/ServiceData";
*/

function App() {
  return (
    <div>
      <Routes>
        {/* De-hosted mode: ALL URLs display the 404 error page */}
        <Route path="*" element={<NotFound />} />

        {/* 
          Existing project routes preserved below (uncomment to restore site):
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/aboutdoctor" element={<Aboutdoctor />} />
          <Route path="/service" element={<Service />} />
          <Route path="/servicedata/:name/:id" element={<ServiceData />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blogdata/:blogname/:id" element={<BlogData />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/carrier" element={<Carrier />} />
        */}
      </Routes>
    </div>
  );
}

export default App;
